import React, { useEffect, useState } from "react";
import Footer from "containers/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import useSystemsDataHandler from "hooks/useSystemsDataHandler";

import { landingPageStrings } from "constants/constantStrings";

import PageLoading from "components/PageLoading";

import NoSystemAssignedScreen from "./NoSystemAssignedScreen";
import SystemsAndAlarmsView from "./SystemsAndAlarmsView";

import "./index.scss";

const SystemsAndAlarms = props => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { loadSystemsData } = useSystemsDataHandler();

  const state = useSelector(state => state);
  const { activeAlarms } = state.poll;
  const anomalyData = state.smartInsights.data;
  const { history } = props;
  const { fetching, error, systemsAsObj } = state.systems;
  const [pageError, setPageError] = useState(error);
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, isAuthorized, hasSystemsAccess, isAdmin } = state.user;

  const systems = Object.values(systemsAsObj);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await loadSystemsData();
      setIsLoading(false);
    };
    const reloadData = location.state?.reloadData;
    if (reloadData) {
      fetchData();
    }
  }, []);

  const getLandingPageView = () => {
    let view;
    if (pageError) {
      view = <div className="page-error">{landingPageStrings.tryAgain}</div>;
    } else if (isLoading) {
      view = <PageLoading customHeight={"calc(100vh - 108px)"} />;
    } else if (!hasSystemsAccess) {
      view = <NoSystemAssignedScreen />;
    } else {
      const data = { systems, history, activeAlarms, anomalyData };
      view = <SystemsAndAlarmsView {...data} />;
    }
    return view;
  };

  return (
    <div>
      <div className={`SystemsAndAlarms collapsible-drawer app-main-container`}>{getLandingPageView()}</div>
      <Footer />
    </div>
  );
};

export default SystemsAndAlarms;
